import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { UserResponsivenessDto } from '../../../users/user-responsiveness.dto';

export class PropertyOwnerSummaryDto {
  @IsString()
  @IsNotEmpty()
  id!: string;

  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsOptional()
  @IsDate()
  memberSince?: Date;

  @IsOptional()
  @IsBoolean()
  isVerified?: boolean;

  @IsOptional()
  @IsNumber()
  rating?: number;

  @IsOptional()
  @IsString()
  responseTime?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => UserResponsivenessDto)
  responsiveness?: UserResponsivenessDto;
}
